import { IReduxStore } from 'Redux/Store/IReduxStore';
import { getServerOption } from "Redux/Query";

export const getSiteName = (state: IReduxStore) => getServerOption(state, 'siteName', 'MealOrderingPage');